import React from "react";
import { ClockIcon, LocationIcon, VerticalLine } from "../utils/icons";
import ShapeChart from "../Components/Charts/ShapeChart";
import { Badge, Col, Progress, Row } from "antd";
import AttemptSummary from "./AttemptSummary";
import CourseSlider from "../Components/Courses/CourseSlider";
import LoadingCom from "../Components/LoadingCom";
import { useNavigate } from "react-router-dom";
import audioImage from "../assets/images/audioImage.svg";
import CommunicationImage from "../assets/images/CommunicationImage.svg";
import ProblemImage from "../assets/images/ProblemImage.svg";
import socialSkillImage from "../assets/images/socialSkillImage.svg";

function AttemptAssessmentTab({ AttemptedData }) {
  const navigate = useNavigate();
  const filterData = AttemptedData?.filter((items) => {
    return items?.assessmentStatus !== "deleted";
  });

  const imagesArray = [
    audioImage,
    CommunicationImage,
    ProblemImage,
    socialSkillImage,
  ];
  console.log("🚀 ~ AttemptAssessmentTab ~ AttemptedData:", AttemptedData);
  return (
    <div className="mb-10">
      <Row gutter={[10, 10]}>
        {filterData?.length ? (
          filterData?.map((course, items) => (
            <Col
              lg={8}
              md={12}
              // onClick={() => handleBoxClick(course)}
              key={course.assessmentId}
              className="cursor-pointer"
              onClick={() =>
                navigate(`/assessment-result`, {
                  state: { data: course },
                })
              }
            >
              <div className="bg-pureWhite rounded-xl p-3 h-full flex flex-col justify-between">
                <Badge.Ribbon
                  text={course.assessmentStatus}
                  color={
                    course.assessmentStatus === "deleted" ? "red" : "green"
                  }
                />
                {/* <img
                  className="rounded-lg h-[140px] w-[241px]"
                  src="https://www.unityoga.org/uploads/2/5/7/4/25747040/research-assessment-evaluation-fb_orig.jpg"
                  alt={course?.assessmentName}
                  width={241}
                  height={140}
                /> */}
                <div className="h-[150px] bg-[#FA7B2C] rounded-xl flex items-center pl-5 hover:shadow-none shadow-test">
                  <img
                    src={imagesArray[items]}
                    className="transform transition-transform duration-1000 ease-in-out hover:translate-x-10"
                    alt={imagesArray[items]}
                  />
                </div>
                <div className="flex justify-between items-center mt-2">
                  <p className="text-base text-black font-semibold">
                    {course?.assessmentName}
                  </p>
                  <p className="text-[10px] text-gray-400">
                    {/* {course?.updatedAt} */}
                    {course.assessmentDuration + "min"}
                  </p>
                </div>
                <div className="flex justify-between items-center mt-2"></div>
              </div>
            </Col>
          ))
        ) : (
          <div className="text-center  w-full">
            {/* <LoadingCom /> */}
            <h1 className="bg-signupTextBg inline-block text-transparent bg-clip-text font-semibold text-lg ">
              You Haven't Attempt Any Assessment Yet
            </h1>
          </div>
        )}
      </Row>
    </div>
  );
}

export default AttemptAssessmentTab;
